module.exports = __webpack_public_path__ + "images/assets/47caf1bbb34dd8afbfae182c859a1214.svg";